module.exports = __webpack_public_path__ + "static/media/Hoothoot_gaussian2.3ba13c5a.png";